/**
 * Fetcher Area
 * @author Tevin
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FArea extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/area/', '/Home/Area/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取门店列表（门店列表）
    getStoreList(search, pagination, sorter) {
        const url = this.spellURL('getStoreList', 'store_list');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店列表（筛选项）
    getStoresAsSelect() {
        const url = this.spellURL('getStoreListFilter', 'getStore');
        const send = {};
        return this.post(url, send).then(res => {
            if (!res) {
                return null;
            }
            return (res.rows || []).map(item => ({
                id: item.id,
                name: item.name,
            }));
        });
    }

    // 获取门店分类气瓶计数（门店列表）
    getStoreTypeBottle(bottleSet) {
        const url = this.spellURL('getStoreTypeBottle', 'store_bottle_spec_count');
        const send = {
            ...bottleSet,
        };
        return this.post(url, send);
    }

    // 获取门店可编辑信息（门店列表）
    getStoreInfo(store) {
        const url = this.spellURL('getStoreInfo', 'shopInfo');
        const send = {
            ...store,
        };
        return this.post(url, send);
    }

    // 保存添加门店基本信息（门店列表）
    saveAddStoreInfo(store) {
        const url = this.spellURL('saveAddStoreInfo', '../../lpg/admin/store/addStore');
        const send = {
            ...this.transKeyName('underline', this.trimEndsSpace(store)),
        };
        return this.post(url, send);
    }

    // 保存编辑门店基本信息（门店列表）
    saveEditStoreInfo(store) {
        const url = this.spellURL('saveEditStoreInfo', '../../lpg/admin/store/editStore');
        const send = {
            ...this.transKeyName('underline', this.trimEndsSpace(store)),
        };
        return this.post(url, send);
    }

    // 删除门店（门店列表）
    deleteStore(store) {
        const url = this.spellURL('saveDeleteStore', '../../lpg/admin/store/deleteStore');
        const send = {
            ...store,
            type: 'del',
        };
        return this.post(url, send);
    }

    // 获取门店详情（门店列表-门店详情）
    getStoreDetail(store) {
        const url = this.spellURL('getStoreDetail', 'shopInfo');
        const send = {
            ...store,
        };
        return this.post(url, send);
    }

    // 生成门店巡查二维码（门店列表-门店详情）
    getStoreNewQRCode(store) {
        const url = this.spellURL('getStoreNewQRCode', '../Shop/generate_qrcode');
        const send = {
            ...store,
        };
        return this.post(url, send);
    }

    // 获取门店在职员工（门店列表-门店详情）
    getStoreEmployees(search, pagination, sorter) {
        const url = this.spellURL('getStoreEmployees', 'store_detail');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            type: 'work-emp',
        };
        return this.post(url, send);
    }

    // 获取门店挂职员工列表（门店列表-门店详情）
    getStoreTemporaries(search, pagination, sorter) {
        const url = this.spellURL('getStoreTemporaries', 'store_detail');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            type: 'ins-emp',
        };
        return this.post(url, send);
    }

    // 删除挂职员工（门店列表-门店详情）
    deleteStoreTemporary(temporary) {
        const url = this.spellURL('deleteStoreTemporary', 'api_pull_employee');
        const send = {
            ...this.transKeyName('underline', temporary),
            type: 'del',
        };
        return this.post(url, send);
    }

    // 获取门店不在职未挂职的配送员列表（门店列表-门店详情）
    getStoreOutDeliverers(store) {
        const url = this.spellURL('getStoreOutDeliverers', 'employee_list');
        const send = {
            ...this.transKeyName('underline', store),
        };
        return this.post(url, send, { remap: [['', 'emp', 'rows']] });
    }

    // 保存添加挂职员工（门店列表-门店详情）
    saveStoreAddTemporaries(temporaries) {
        const url = this.spellURL('saveStoreAddTemporaries', 'api_pull_employee');
        const send = {
            ...this.transKeyName('underline', temporaries),
        };
        return this.post(url, send);
    }

    // 获取门店气瓶分类计数（门店列表-门店详情）
    getStoreBottleCounts(search, pagination, sorter) {
        const url = this.spellURL('getStoreBottleCounts', 'store_detail');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            type: 'bottle',
        };
        return this.post(url, send);
    }

    // 获取门店类型气瓶列表（门店列表-门店详情）
    getStoreTypeBottleList(search) {
        const url = this.spellURL('getStoreTypeBottleList', 'store_detail');
        const send = {
            ...this.transKeyName('underline', search),
            type: 'bottle_detail',
        };
        return this.post(url, send, { remap: [['', 'bottle', 'rows']] });
    }

    // 获取门店气瓶流转记录（门店列表-门店详情）
    getStoreBottleCirculation(search, pagination, sorter) {
        const url = this.spellURL(
            'getStoreBottleCirculation',
            '../../lpg/admin/Store/bottlePosition',
        );
        const send = {
            ...search,
            page_num: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店气瓶流转详情（门店详情）
    getStoreBottleCircleDetail(circle) {
        const url = this.spellURL('getStoreBottleCircleDetail', 'store_gangping');
        const send = {
            ...circle,
        };
        return this.post(url, send);
    }

    // 获取门店状态（门店状态）
    getStoreStatus(search, pagination, sorter) {
        const url = this.spellURL('getStoreStatus', 'shop_status');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店销售统计（门店销售统计）
    getStoreSalesStatistic(search, pagination, sorter) {
        const url = this.spellURL('getStoreSalesStatistic', '../../lpg/admin/Store/Sale');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                stores: search.stores?.join(','),
                storeType: search.storeType || 0,
                subsidiary: search.subsidiary || 0,
            }),
            page_num: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店销售记录详情（门店销售统计）
    getStoreSalesDetail(store) {
        const url = this.spellURL('getStoreSalesDetail', '../../lpg/admin/store/saleDetail');
        const send = {
            ...this.transKeyName('underline', store),
            time: store.time?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取门店地图（门店地图）
    getStoreMap(search) {
        const url = this.spellURL('getStoreMap', 'store_map');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send, { remap: [['', 'totalpage', 'totalPage']] });
    }

    // 获取门店在用气瓶计数（门店在用气瓶）
    getStoreUsingBottles(search, pagination, sorter) {
        const url = this.spellURL('getStoreUsingBottles', '../../lpg/admin/Store/inUseBottle');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: {
                useBottleCnt: 'useBottleCnt',
                depositCnt: 'depositCnt',
            }[sorter.field],
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店重瓶计数（门店重瓶库存）
    getStoreHeavyBottleCount(search, pagination, sorter) {
        const url = this.spellURL('getStoreHeavyBottleCount', 'store_inventory');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取门店轻瓶计数（门店轻瓶库存）
    getStoreLightBottleCount(search, pagination, sorter) {
        const url = this.spellURL('getStoreLightBottleCount', 'store_inventory');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取门店气瓶流转信息（门店重瓶库存、门店轻瓶库存）
    getStoreBottleTransit(transit) {
        const url = this.spellURL('getStoreBottleTransit', 'inventory_detail');
        const send = {
            ...this.transKeyName('underline', transit),
        };
        return this.post(url, send);
    }

    // 保存导出门店重瓶、轻瓶库存（门店重瓶库存、门店轻瓶库存）
    saveExportStoreInventory(search) {
        const url = this.spellURL(
            'saveExportStoreInventory',
            '../../lpg/admin/store/exportStoreInventory',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取门店收款记录（门店收款报表）
    getStoreCollections(search, pagination, sorter) {
        const url = this.spellURL('getStoreCollections', '../../lpg/admin/store/storeCollection');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店配送报表
    getStoreDeliveryReport(search, pagination, sorter) {
        const url = this.spellURL('getStoreDeliveryReport', '../../lpg/admin/Store/shop_delivery');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店配送重量目标列表（门店配送重量目标）
    getStoreSalesTargetList(search, pagination) {
        const url = this.spellURL(
            'getStoreSalesTargetList',
            '../../lpg/admin/Store/sales_target_list',
        );
        const send = {
            ...this.transKeyName('underline', {
                ...search,
            }),
            page: pagination.current,
            limit: pagination.pageSize,
        };
        return this.post(url, send);
    }

    // 获取门店配送重量目标详情（门店配送重量目标）
    getStoreSalesTargetDetail(storeId, year) {
        const url = this.spellURL(
            'getStoreSalesTargetDetail',
            '../../lpg/admin/Store/sales_target_detail',
        );
        const send = this.transKeyName('underline', { storeId, year });
        return this.post(url, send);
    }

    // 保存门店配送重量目标（门店配送重量目标）
    saveStoreSalesTarget(data) {
        const url = this.spellURL(
            'saveStoreSalesTarget',
            '../../lpg/admin/Store/sales_target_save',
        );
        const send = this.transKeyName('underline', data);
        return this.post(url, send);
    }

    // 获取营业员提成（营业员提成）
    getSalespersonCommissionList(search, sorter) {
        const url = this.spellURL(
            'getSalespersonCommissionList',
            '../../lpg/admin/Emp/Commisson/salesClerkCommissonList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取营业员提成详情（营业员提成）
    getSalespersonCommissionDetail(search, sorter) {
        const url = this.spellURL(
            'getSalespersonCommissionDetail',
            '../../lpg/admin/Emp/Commisson/salesClerkCommissonDetails',
        );
        const send = {
            ...this.transKeyName('underline', search),
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取门店存款明细列表（门店存款明细）
    getStoreDepositRecords(search, pagination, sorter) {
        const url = this.spellURL(
            'getStoreDepositRecords',
            '../../lpg/admin/financialManagement/Report/getSavingsDetailList',
        );
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存门店存款记录（门店存款明细）
    saveStoreDepositRecord(data) {
        const url = this.spellURL(
            'saveStoreDepositRecord',
            '../../lpg/admin/store/saveSavingsRecord',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取存款记录详情（门店存款明细）
    getDepositRecordDetail(data) {
        const url = this.spellURL(
            'getDepositRecordDetail',
            '../../lpg/admin/store/getSavingsRecordDetail',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 审核门店存款记录（门店存款明细）
    saveExamineDepositRecord(data) {
        const url = this.spellURL(
            'saveExamineDepositRecord',
            '../../lpg/admin/financialManagement/Report/auditSavingsRecord',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存导出门店存款记录（门店存款明细）
    saveExportStoreDepositRecords(data) {
        const url = this.spellURL(
            'saveExportStoreDepositRecords',
            '../../lpg/admin/financialManagement/Report/exportSavingsDetail',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取门店购销存日报表（门店购销存日报表）
    getStoreInventoryDailyList(search) {
        const url = this.spellURL(
            'getStoreInventoryDailyList',
            '../../lpg/admin/report/storeInventory/dailyList',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取门店购销存月报表（门店购销存月报表）
    getStoreInventoryMonthlyList(search) {
        const url = this.spellURL(
            'getStoreInventoryMonthlyList',
            '../../lpg/admin/report/storeInventory/monthlyList',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存导出门店购销存报表（门店购销存日/月报表）
    saveExportStoreInventoryReport(data) {
        const url = this.spellURL(
            'saveExportStoreInventoryReport',
            '../../lpg/admin/report/storeInventory/export',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取门店购销存报表导出结果
    getStoreInventoryExportResult(data) {
        const url = this.spellURL(
            'getStoreInventoryExportResult',
            '../../lpg/admin/getExportResult',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取收款帐号列表（门店收款账号配置）
    getStorePaymentAccounts(search, pagination, sorter) {
        const url = this.spellURL(
            'getStorePaymentAccounts',
            '../../lpg/admin/store/listPaymentAccounts',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取收款帐号详情（门店收款账号配置）
    getStorePaymentAccountDetail(data) {
        const url = this.spellURL(
            'getStorePaymentAccountDetail',
            '../../lpg/admin/store/getPaymentAccountDetail',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存收款帐号（门店收款账号配置）
    saveStorePaymentAccount(data) {
        const url = this.spellURL(
            'saveStorePaymentAccount',
            '../../lpg/admin/store/savePaymentAccount',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 删除收款帐号（门店收款账号配置）
    saveDeleteStorePaymentAccount(data) {
        const url = this.spellURL(
            'saveDeleteStorePaymentAccount',
            '../../lpg/admin/store/deletePaymentAccount',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存门店绑定（门店收款账号配置）
    saveStorePaymentAccountBind(data) {
        const url = this.spellURL(
            'saveStorePaymentAccountBind',
            '../../lpg/admin/store/bindPaymentAccountStores',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 解绑门店绑定（门店收款账号配置）
    saveStorePaymentAccountUnbind(data) {
        const url = this.spellURL(
            'saveStorePaymentAccountUnbind',
            '../../lpg/admin/store/unbindPaymentAccountStores',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }
}

export const $fetchArea = new FArea();
